module.exports = __webpack_public_path__ + "static/media/ve.d42cffd6.svg";